export default __webpack_public_path__ + "static/media/ai_video.38b5675f.mp4";